function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as SessionGroupMaterialConfirmModalComponent from "./SessionGroupMaterialConfirmModalComponent";
import * as Utility from "../commons/Utility";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import IntlMessage from '../commons/Intl';
import { Action, CreateSphereGroup, Errors, Label, Placeholder } from "../commons/IntlMessages";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // グループ編集モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 編集
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 3] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      SessionGroupMaterialConfirmModalMode: SessionGroupMaterialConfirmModalComponent.Mode.None,
      Group: _this.props.group,
      ErrorMessages: []
    };
    return _this;
  }
  /**
   * 「登録」ボタン押下時の処理を行います。
   */


  _createClass(MainComponent, [{
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null || this.state.Group == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onEntry(this.state.Group);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null || this.state.Group == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onModify(this.state.Group);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 削除時確認ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionGroupMaterialDeleteConfirmModal",
    value: function openSessionGroupMaterialDeleteConfirmModal() {
      this.setState({
        SessionGroupMaterialConfirmModalMode: SessionGroupMaterialConfirmModalComponent.Mode.SessionGroupMaterialDeleteConfirm
      });
    }
    /**
     * 確認ダイアログモーダルで「はい」を選択した際の処理を行います。
     */

  }, {
    key: "yesSessionGroupMaterialConfirmModal",
    value: function yesSessionGroupMaterialConfirmModal(closeEvent) {
      closeEvent();

      if (this.state.Modal == null || this.state.Group == null) {
        throw Error();
      }

      this.props.onDelete(this.state.Group);
      this.state.Modal.modal('hide');
    }
    /**
     * 確認ダイアログモーダルで「いいえ」を選択した際の処理を行います。
     */

  }, {
    key: "noSessionGroupMaterialConfirmModal",
    value: function noSessionGroupMaterialConfirmModal(closeEvent) {
      closeEvent();
    }
    /**
     * 確認ダイアログモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionGroupMaterialConfirmModal",
    value: function hiddenSessionGroupMaterialConfirmModal() {
      this.setState({
        SessionGroupMaterialConfirmModalMode: SessionGroupMaterialConfirmModalComponent.Mode.None
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#SessionSphereGroupModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function (e) {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * グループ名を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSphereGroupName",
    value: function updateSphereGroupName(e) {
      var group = this.state.Group;
      if (!group) return;
      group.MaterialFileName = e.target.value.substring(0, e.target.maxLength) + ".sg";
      group.DisplayFileName = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        Group: group
      });
    }
    /**
     * 素材選択変更
     *
     * @param event 素材情報イベント
     */

  }, {
    key: "onGridReady",
    value: function onGridReady(event) {
      event.api.forEachNode(function (node) {
        if (node.data.Included) {
          node.setSelected(true);
        }
      });
    }
    /**
     * 素材選択変更
     *
     * @param event 素材情報イベント
     */

  }, {
    key: "onRowSelected",
    value: function onRowSelected(event) {
      var group = this.state.Group;
      if (!group) return;
      var selectedFileNames = [];
      var selectedRows = event.api.getSelectedRows();

      if (selectedRows.length > 0) {
        for (var i = 0; i < selectedRows.length; i++) {
          selectedFileNames.push(selectedRows[i].ItemName);
        }
      }

      group.Items.forEach(function (item) {
        item.Included = false;

        if (item.ItemName && selectedFileNames.indexOf(item.ItemName) !== -1) {
          item.Included = true;
        }
      });
      this.setState({
        Group: group
      });
    }
    /**
     * 整形された日付を取得します。
     *
     * @param date 日付
     */

  }, {
    key: "getFormattedDate",
    value: function getFormattedDate(params) {
      if (params.value) {
        return Utility.ToMoment(params.value).format("YYYY-MM-DD HH:mm:ss");
      }

      return "";
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _this$state$Group;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionSphereGroupModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_SphereGroup.svg"
      }), this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("h3", null, intl.format(CreateSphereGroup.Title)), this.props.mode == Mode.Modify && [/*#__PURE__*/React.createElement("h3", null, this.state.Group ? this.state.Group.MaterialFileName : "")], this.props.mode == Mode.ReadOnly && [/*#__PURE__*/React.createElement("h3", null, this.state.Group ? this.state.Group.MaterialFileName : "")]), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-11 mx-auto"
      }, this.props.mode == Mode.Add && [/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, intl.format(CreateSphereGroup.TitleDescription)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, intl.format(CreateSphereGroup.TitleNotes))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SphereGroupName",
        id: "SphereGroupName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this3.updateSphereGroupName(e);
        },
        value: (_this$state$Group = this.state.Group) === null || _this$state$Group === void 0 ? void 0 : _this$state$Group.DisplayFileName,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "150"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "SphereGroupName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))], /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, intl.format(CreateSphereGroup.AssetsDescription))), /*#__PURE__*/React.createElement("div", {
        className: "grid newdesign"
      }, this.state.Group != null && this.state.Group.Items.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "ag-theme-alpine"
      }, /*#__PURE__*/React.createElement(AgGridReact, {
        rowData: this.state.Group.Items,
        defaultColDef: {
          minWidth: 100,
          lockPosition: true,
          resizable: false
        },
        rowHeight: 32,
        headerHeight: 32,
        onGridReady: this.onGridReady.bind(this),
        onRowSelected: this.onRowSelected.bind(this),
        suppressRowClickSelection: true,
        suppressNoRowsOverlay: true,
        rowSelection: "multiple",
        rowClass: "my-row"
      }, /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "ItemName",
        headerName: intl.format(Label.Name),
        headerCheckboxSelection: true,
        checkboxSelection: true,
        minWidth: 120,
        flex: 1
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "LastModified",
        headerName: intl.format(Label.LastModified),
        width: 195,
        valueFormatter: this.getFormattedDate.bind(this)
      }))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer modal-footer-container justify-content-center"
      }, this.props.mode == Mode.Add && this.state.Group && this.state.Group.Items.filter(function (i) {
        return i.Included;
      }).length > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Create)), this.props.mode == Mode.Add && (!this.state.Group || this.state.Group.Items.filter(function (i) {
        return i.Included;
      }).length == 0) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        disabled: true,
        tabIndex: -1
      }, intl.format(Action.Create)), this.props.mode == Mode.Modify && this.state.Group && this.state.Group.Items.filter(function (i) {
        return i.Included;
      }).length > 0 && [/*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.openSessionGroupMaterialDeleteConfirmModal.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete)), /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update))], this.props.mode == Mode.Modify && (!this.state.Group || this.state.Group.Items.filter(function (i) {
        return i.Included;
      }).length == 0) && [/*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.openSessionGroupMaterialDeleteConfirmModal.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete)), /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        disabled: true,
        tabIndex: -1
      }, intl.format(Action.Update))], this.props.mode == Mode.ReadOnly && [/*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))])))), this.state.SessionGroupMaterialConfirmModalMode != SessionGroupMaterialConfirmModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionGroupMaterialConfirmModalComponent["default"], {
        mode: this.state.SessionGroupMaterialConfirmModalMode,
        onYes: this.yesSessionGroupMaterialConfirmModal.bind(this),
        onNo: this.noSessionGroupMaterialConfirmModal.bind(this),
        onHidden: this.hiddenSessionGroupMaterialConfirmModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };